var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLabelIcon = function SvgLabelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m23.313 11.099-5.637-5.881A.7.7 0 0 0 17.173 5H1.233c-.393 0-.712.333-.712.743v11.762c0 .41.32.743.712.743h15.94c.189 0 .37-.078.503-.217l5.637-5.882a.765.765 0 0 0 0-1.05m-6.434 5.663H1.946V6.485h14.933l4.924 5.139z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.675 9.333h7.712v1.114H4.675zm0 3.467h6.556v1.114H4.675zm9.967-2.353h2.254V12.8h-2.254z"
  })));
};
export { SvgLabelIcon as ReactComponent };